import {
  DetailCode,
  DetailField,
  DetailGrid,
  DetailNote,
  DetailPanel,
} from "../../../Components/common/DetailPanel/DetailPanel";
import { formatTransferTime, TRANSFER_STATUS_LABELS } from "./transferLogCells";

// postfix "delays=a/b/c/d"
const DELAY_PARTS = [
  "Before the queue manager",
  "Waiting in the queue",
  "Connection setup",
  "Message transmission",
];

// DSN class (first digit) and the most common RFC 3463 subject.detail codes
const DSN_CLASSES = {
  2: "Success",
  4: "Temporary failure",
  5: "Permanent failure",
};

const DSN_DETAILS = {
  1.1: "recipient mailbox does not exist",
  1.2: "recipient domain does not exist",
  2.1: "recipient mailbox disabled",
  2.2: "recipient mailbox full",
  4.1: "no answer from the receiving host",
  4.2: "connection dropped",
  4.4: "unable to route the message",
  4.7: "delivery time expired",
  7.1: "rejected by the receiving server's policy",
};

const describeDsn = (dsn) => {
  const match = /^(\d)\.(\d{1,3}\.\d{1,3})$/.exec(dsn || "");
  if (!match) return "";
  return [DSN_CLASSES[match[1]], DSN_DETAILS[match[2]]].filter(Boolean).join(", ");
};

const STATUS_NOTES = {
  blocked:
    "The gateway held this mail after analysis, so it was never relayed. It is listed under Blocked Emails, where it can be released.",
  "not delivered":
    "No delivery attempt was logged within 13 minutes of queueing, and the gateway did not block it.",
  deferred: "The receiving side answered with a temporary error; postfix keeps retrying.",
  bounced: "The receiving side refused the mail permanently; the sender gets a bounce notice.",
};

const NOTE_TONES = {
  blocked: "muted",
  "not delivered": "info",
  deferred: "warning",
  bounced: "danger",
};

// Rendered by ReactTableWrapper as `<expandConfig.subComponent row={row} />`
const TransferLogDetail = ({ row }) => {
  const record = row?.original || {};
  const delays = String(record.delays || "")
    .split("/")
    .filter((part) => part !== "" && !isNaN(parseFloat(part)));
  const dsnText = describeDsn(record.dsn);

  return (
    <DetailPanel>
      {STATUS_NOTES[record.status] && (
        <DetailNote tone={NOTE_TONES[record.status]} title={TRANSFER_STATUS_LABELS[record.status]}>
          {STATUS_NOTES[record.status]}
        </DetailNote>
      )}
      <DetailGrid>
        <DetailField label="Message-ID">{record.message_id}</DetailField>
        <DetailField label="Queue ID">{record.queue_id}</DetailField>
        <DetailField label="Gateway">{record.device}</DetailField>
        <DetailField label="Queued at">{formatTransferTime(record.date)}</DetailField>
        <DetailField label="Finished at">{formatTransferTime(record.delivered_at)}</DetailField>
        <DetailField label="Next hop">{record.relay === "timeout" ? "" : record.relay}</DetailField>
        <DetailField label="DSN">
          {record.dsn ? `${record.dsn}${dsnText ? ` (${dsnText})` : ""}` : null}
        </DetailField>
        <DetailField label="Total delay">
          {isNaN(parseFloat(record.delay)) ? null : `${parseFloat(record.delay)} s`}
        </DetailField>
        {delays.length === DELAY_PARTS.length && (
          <DetailField label="Delay breakdown" wide>
            <span className="detail-panel__inline-list">
              {DELAY_PARTS.map((label, index) => (
                <span key={label}>
                  {label} <b>{delays[index]} s</b>
                </span>
              ))}
            </span>
          </DetailField>
        )}
        <DetailField label="Server response" wide>
          {record.message ? <DetailCode>{record.message}</DetailCode> : null}
        </DetailField>
      </DetailGrid>
    </DetailPanel>
  );
};

export default TransferLogDetail;
